var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMusicNote(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9187 0.00700555L6.01875 1.35421C5.11875 1.44543 4.5 2.25235 4.5 3.15049V12.3845C4.08516 12.3108 3.63516 12.3108 3.15 12.4125C1.44141 12.8616 0 14.3667 0 15.8928C0 17.419 1.44141 18.3346 3.15 17.8856C4.85859 17.4365 6.3 15.9033 6.3 14.3772V6.65884L16.2 5.3397V11.4302C15.7852 11.3565 15.3352 11.3881 14.85 11.5144C13.1414 11.9635 11.7 13.4685 11.7 14.9947C11.7 16.5208 13.1414 17.4365 14.85 16.9874C16.5586 16.5384 18 15.0052 18 13.4791V1.80328C18 0.726217 16.998 -0.0842111 15.9187 0.00700555Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusicNote);
export default __webpack_public_path__ + "static/media/music-note.c8133cd5ba79abbe243f58fbb9fed478.svg";
export { ForwardRef as ReactComponent };